import { metricNames } from '@linearb/linjs-common';
import Autocomplete from 'components/base/Autocomplete';
import React from 'react';
import {
  StyledDescription,
  StyledInputWrapper,
  StyledSelectorTitle
} from './ReportedMetricsModal.style';

export const ReportedMetricSelector = ({
  metrics,
  modalState,
  setModalState
}) => (
  <StyledInputWrapper>
    <StyledSelectorTitle>REPORTED METRICS</StyledSelectorTitle>
    <StyledDescription>
      Select the key performance indicator or data point you wish to analyze
    </StyledDescription>
    <Autocomplete
      width='32rem'
      value={modalState.reportedMetric}
      onChange={reportedMetric => {
        setModalState({ ...modalState, reportedMetric });
      }}
      options={(metrics?.data || []).map(({ metric_name }) => ({
        value: metric_name,
        displayValue: metric_name,
        searchableValue: metric_name
      }))}
      placeholder={
        modalState.reportedMetric === metricNames.REPORTED_CUSTOM
          ? 'Select option'
          : modalState.reportedMetric
      }
      itemsTooltipEnabled
    />
  </StyledInputWrapper>
);
